
import { FC, useContext } from "react";

import { Flex } from "antd";
import { ActionButton } from "@hdi-seguros/web-components.action-button";

import { Form, ColSize, ContentSection, RadioForm, RowSize } from "../../../../../../shared/components";

import PreLiquidationService from "../../../../../../shared/services/collection/preliquidation";

import { GenericDataFormContext } from "../../contexts/GenericDataForm";

import { PreliquidationLoadingCard } from "../PreliquidationLoadingCard";

import { DECISION_TYPE } from "../../../../../../shared/interfaces";
import { PreLiquidationStep } from "../../interfaces";

import { ValidateForm } from "../../../../../../shared/utils";

interface PreliquidationInitialStepProps {}

export const PreliquidationInitialStep: FC<PreliquidationInitialStepProps> = () => {
  const { setCanShowSpinner, canShowSpinner, setCurrentStep, setPreliquidationInfo, preliquidationInitialForm } = useContext(GenericDataFormContext);
  const validateForm = new ValidateForm();

  const OPTION_YES_OR_NOT: {
    label: string;
    value: string;
  }[] = [
      {
        label: 'SI',
        value: DECISION_TYPE.YES,
      },
      {
        label: 'NO',
        value: DECISION_TYPE.NO,
      },
    ];


  const onFinishForm = async (values: { hasAutomaticDebit: string }) => {
    setCanShowSpinner(true);
    try {
      const resp = await PreLiquidationService.generateNewPreliquidation(values.hasAutomaticDebit === DECISION_TYPE.YES);
      setPreliquidationInfo(resp.data);
      setCanShowSpinner(false);
      setCurrentStep(PreLiquidationStep.ONE);
    } catch (error) {
      /** Nothing... */
    } finally {
      setCanShowSpinner(false);
    }
  }

  return <>
    <Form
      formProps={{
        form: preliquidationInitialForm,
        onFinish: onFinishForm,
        name: 'preliquidationInitial-form',
      }}
    >
      <RowSize>
        <ColSize size={80}>
          {
            canShowSpinner
              ? <PreliquidationLoadingCard />
              : (
                <ContentSection title='Generación de preliquidación'>
                  <RowSize>
                    <ColSize size={100}>
                      <RadioForm
                        formProps={{
                          rules: validateForm.generateRules({
                            label: 'inclusión de débito automático',
                            rules: ['required'],
                          }),
                          label: '¿Desea incluir en esta preliquidación las cuotas con débito automático (tarjeta de crédito y débito bancario)?',
                          name: 'hasAutomaticDebit',
                        }}
                        options={OPTION_YES_OR_NOT}
                      />
                    </ColSize>
                  </RowSize>
                </ContentSection>
              )
          }
         
         {
          !canShowSpinner
            ? (
              <RowSize>
                <ColSize size={100}>
                  <Flex gap="middle" align="end" vertical>
                    <ActionButton
                      className='btn-principal-barbuss'
                      label='Continuar'
                      disabled={canShowSpinner}
                      htmlType="submit"
                    />
                  </Flex>
                </ColSize>
              </RowSize>
            )
            : <></>
         }
        </ColSize>
      </RowSize>
    </Form>
  </>
}

